import React from "react";
import PropTypes from "prop-types";
import ProgressBar from "./progress-bar";
var StepHeader = function StepHeader(_ref) {
  var header = _ref.header,
    currentStep = _ref.currentStep,
    totalSteps = _ref.totalSteps;
  return /*#__PURE__*/React.createElement("div", {
    className: "step__header"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "step__header__title",
    dangerouslySetInnerHTML: {
      __html: header
    }
  }), /*#__PURE__*/React.createElement(ProgressBar, {
    currentStep: currentStep + 1,
    totalSteps: totalSteps - 1
  }));
};
export default StepHeader;
StepHeader.propTypes = {
  header: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
};